import { render } from "./InstallWizardGroupReportSetup.vue?vue&type=template&id=398568a4"
import script from "./InstallWizardGroupReportSetup.vue?vue&type=script&lang=js"
export * from "./InstallWizardGroupReportSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__